import "core-js/modules/es.array.push.js";
import AppFooter from "@/components/AppFooter";
import AppHeader from "@/components/AppHeader";
import AdminHeader from "@/components/admin/AdminHeader";
import { ToastProgrammatic as Toast } from 'buefy';
export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
    AdminHeader
  },
  beforeCreate() {
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        if ([400, 401].includes(err.response.status) && err.response.config && !err.response.config.__isRetryRequest) {
          if (['sessionExpired', 'unauthorized', 'invalidAuthorizationToken'].includes(err.response.data.errorCode)) {
            Toast.open('Sua sessão expirou');
            if (err.response.data.errorCode !== 'invalidAuthorizationToken') {
              localStorage.removeItem('user-token');
              localStorage.removeItem('restriction');
              this.$store.commit('authNone');
            }
            // if you ever get an unauthorized, logout the user
            if (this.$store.getters.token) {
              this.$store.dispatch('authLogout').then(() => {
                this.$router.push({
                  path: '/login'
                });
              });
            } else {
              this.$router.push({
                path: '/login'
              });
            }
          }
        }
        reject(err.response);
      });
    });
  }
};